import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { CashInstructionDto } from '@/features/dashboard/paymentConfig/types/CashInstructionDto.ts';

const cashInstructionApi = {
  get: async (): Promise<CashInstructionDto> => {
    return await fetchPrivateApi<CashInstructionDto>(
      'GET',
      'settings/payments/cash-instruction',
    );
  },
  set: async (dto: CashInstructionDto): Promise<CashInstructionDto> => {
    return await fetchPrivateApi<CashInstructionDto>(
      'PUT',
      'settings/payments/cash-instruction',
      dto,
    );
  },
};

export default cashInstructionApi;
